import {Component, Injector, OnInit} from "@angular/core";
import {SimUtilityExtendedService} from "@services";
import {BasicMaterialDialog, MatDialogDataBaseInput} from "../../basic-material-dialog/basic-material-dialog.directive";
import {Media} from "@models";

export interface MEDIA_DIALOG_BASE_INPUT extends MatDialogDataBaseInput {
	media: Media;
}

@Component({
	selector: "sim-media-image-dialog",
	templateUrl: "./media-image-dialog.component.html",
	styleUrls: ["./media-image-dialog.component.scss"],
	standalone: false,
})
export class MediaImageDialogComponent extends BasicMaterialDialog<MediaImageDialogComponent, MEDIA_DIALOG_BASE_INPUT> implements OnInit {
	public mediaUrl: string;

	constructor(
		_injector: Injector,
		private _simUtilityService: SimUtilityExtendedService,
	) {
		super(_injector);
		this.mediaUrl = this._simUtilityService.getMediaPath(this.data.media);
	}

	public stop() {
		this.close({action: "ok"});
	}

	public cancel() {
		this.close({action: "cancel"});
	}
}
